function NotificationService(ApiService) {
  'ngInject';
  const service = {};

  service.getNotifications = function(url , callbackFunc) {
    ApiService.get(url, callbackFunc);
  };
  service.markAsRead = function(id, callbackFunc) {
    let url = id ? `/notifications/mark.json?id=${id}` : `/notifications/mark.json`;
    ApiService.post(url, {}, callbackFunc);
  };
  return service;
}

export default{
  name: 'NotificationService',
  fn: NotificationService
}
